import { OrderList } from '../../order/order-list';
import { OrderDocumentType } from '../../../clients/quipli-service/order/order';

export const CreditMemoList = () => {
  return (
    <>
      <OrderList
        title="Credit Memos"
        createOrderButton={false}
        scanQrButton={false}
        allowWorkFlowStatusFilter={false}
        allowedColumns={[
          'OrderNumber',
          'CustomerName',
          'CustomerPhone',
          'Location',
          'Delivery',
          'Amount',
          'CreatedBy',
          'Status',
        ]}
        documentType={OrderDocumentType.CreditMemo}
      />
    </>
  );
};
